import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import AGB from "../pages/agb/page";
import CookieRichtlinie from "../pages/cookie-richtlinie/page";
import Blog from "../pages/blog/page";
import HilfeCenter from "../pages/hilfe-center/page";
import CaseStudies from "../pages/case-studies/page";
import BlogArticle from "../pages/blog-article/page";
import CaseStudyDetail from "../pages/case-study-detail/page";
import Demo from "../pages/demo/page";
import PartnerOnboarding from "../pages/partner-onboarding/page";
import PartnerSuccess from "../pages/partner-success/page";
import PartnerLogin from "../pages/partner-login/page";
import PartnerDashboard from "../pages/partner-dashboard/page";
import AdminLogin from "../pages/admin-login/page";
import AdminDashboard from "../pages/admin-dashboard/page";
import ManageSubscription from "../pages/manage-subscription/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/demo",
    element: <Demo />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <AGB />,
  },
  {
    path: "/cookie-richtlinie",
    element: <CookieRichtlinie />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "/hilfe-center",
    element: <HilfeCenter />,
  },
  {
    path: "/case-studies",
    element: <CaseStudies />,
  },
  {
    path: "/case-studies/:slug",
    element: <CaseStudyDetail />,
  },
  {
    path: "/partner-onboarding",
    element: <PartnerOnboarding />,
  },
  {
    path: "/partner-success",
    element: <PartnerSuccess />,
  },
  {
    path: "/partner-login",
    element: <PartnerLogin />,
  },
  {
    path: "/partner-dashboard",
    element: <PartnerDashboard />,
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/admin-dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/manage-subscription",
    element: <ManageSubscription />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
